import Button from '@zenbusiness/zui/Button';
import { superstyled } from '@zenbusiness/zui/styles';

export const ActionButton = superstyled({
  tag: Button,
  name: 'QuickActions',
  slot: 'ActionButton',
  styles: {
    justifyContent: 'flex-start',
  },
});
